function u(n, d, i, t) {
  for (var l = n.length, e = i + (t ? 1 : -1); t ? e-- : ++e < l; )
    if (d(n[e], e, n))
      return e;
  return -1;
}
export {
  u as default
};
